(function($) {

	// open & close the modal
	$(document).on('click', '.open-card-modal', function(e) {
		e.preventDefault()
		openCardModal()
	})
	$(document).on('click', '.card-modal .close-modal, .card-modal-overlay', function() {
		closeCardModal()
	})

	// select a card
	$(document).on('click', '.card-modal .card-option', function() {
		var selected_card = $(this).data('card')
		$('#gift-card-dropdown').val(selected_card).trigger('change')
		closeCardModal()
	})

	// remove selected card
	$(document).on('click', '.remove-card', function() {
		$('#gift-card-dropdown').val('').trigger('change')
		closeCardModal()
	})

	// when changing card
	$(document).on('change', '#gift-card-dropdown', function() {
		var selected_card = $(this).val()
		var selected_card_name = $(this).find(":selected").text()

		if (selected_card == '') {
			hideCardMessageForm()
		} else {
			showCardMessageForm(selected_card, selected_card_name)
		}
	})

	//when no card selection
	$(document).on('click', '.gift-card-pick-button.no-cards', function() {
		$(this).hide()
		$('#gift-card-form-wrapper').show()
		var datePickerInput = $('#gift-card-form-wrapper #gsDatepickerRow').find("input.gs__delivery-date:text")
		datePickerInput.attr("placeholder", "Shipping Date");
		datePickerInput.attr("name", "properties[Shipping Date]");
		datePickerInput.find("input.gs__delivery-date:text").attr("aria-label", "Shipping Date");
		$('#gift-card-form-wrapper #gsDatepickerRow').find("label[for='gsDeliveryDate']").text("Shipping Date");
	})

	function hideCardMessageForm() {
		$('#gift-card-form-wrapper').hide()
		$('.gift-card-pick-button').show()
	}
	function showCardMessageForm(card_name, card_name_unhandleized) {

		let handleizedCard = card_name.replace(' ',  '-').toLowerCase();

		$('#preview-card-name').text(card_name_unhandleized);

		$('#gift-card-form-wrapper').show().removeClass().addClass(card_name);
		$('.card-preview').removeClass('selected');
		$('.card-preview.' + handleizedCard).addClass('selected');
		$('.gift-card-pick-button').hide()
		var datePickerInput = $('#gift-card-form-wrapper #gsDatepickerRow').find("input.gs__delivery-date:text")
		datePickerInput.attr("placeholder", "Shipping Date");
		datePickerInput.attr("name", "properties[Shipping Date]");
		datePickerInput.find("input.gs__delivery-date:text").attr("aria-label", "Shipping Date");
		$('#gift-card-form-wrapper #gsDatepickerRow').find("label[for='gsDeliveryDate']").text("Shipping Date");

	}

	function openCardModal() {
		$('.card-modal-wrapper').fadeIn()
	}
	function closeCardModal() {
		$('.card-modal-wrapper').fadeOut()
	}

})(jQuery)
